<template>
    <div
        :style="{ width: width + 'px', height: height + 'px', 'line-height': height + 'px', 'border-radius': radius }"
        class="vi_avatar"
    >
        <img v-if="avatar && !imgerror" :src="avatar" class="img" @error="imgErrfn" />
        <label v-else-if="name" :style="randomColor()" class="name">{{ name.substr(0, 1) }}</label>
        <img v-else class="img" :src="require('../../assets/images/common/default_avatar.svg')" alt />
    </div>
</template>

<script>
/**
 * ComponentName: 用户头像组件
 * Created Date:2021/9/17
 * Author: dhg
 * Modifier: pyh
 * 组件说明：
 * 传值：
 *     属性名    类型      说明
 *     avatar  String  云端已登录时用户头像
 *     name    String  云端已登录时用户如果没有头像,则默认取name的第一个字符,并给一个随机的颜色作为用户头像
 *     width   Number | String  组件宽度,默认为20px
 *     height  Number | String  组件高度,默认为20px
 *     radius  Number | String  组件圆弧度,默认为50%
 * eg:
 *     <vi-avatar :avatar="userAvatar" :name="userName" width="22" height="22"></vi-avatar>
 */

export default {
    name: 'cl-vi-avatar',
    props: {
        // 用户头像
        avatar: {
            type: String,
            default: '',
        },
        // 用户名称
        name: {
            type: String,
            default: '',
        },
        // 组件宽度
        width: {
            type: Number | String,
            default: 20,
        },
        // 组件高度
        height: {
            type: Number | String,
            default: 20,
        },
        // border-radius
        radius: {
            type: String,
            default: '50%',
        },
    },
    data() {
        return {
            imgerror: false,
            customColorList: [
                {
                    hex: '#FFFFFF', // 16进制颜色
                    rgb: '255, 255, 255', // rgb颜色
                },
                {
                    hex: '#E23838',
                    rgb: '226, 56, 56',
                },
                {
                    hex: '#FF6536',
                    rgb: '255, 101, 54',
                },
                {
                    hex: '#FD6F10',
                    rgb: '253, 111, 16',
                },
                {
                    hex: '#FFAD24',
                    rgb: '255, 173, 36',
                },
                {
                    hex: '#ED3A85',
                    rgb: '237, 58, 133',
                },
                {
                    hex: '#C640F2',
                    rgb: '198, 64, 242',
                },
                {
                    hex: '#9F25FF',
                    rgb: '159, 37, 255',
                },
                {
                    hex: '#36D7FF',
                    rgb: '54, 215, 255',
                },
                {
                    hex: '#409FFF',
                    rgb: '64, 159, 255',
                },
                {
                    hex: '#3663E1',
                    rgb: '54, 99, 225',
                },
                {
                    hex: '#4CC85C',
                    rgb: '76, 200, 92',
                },
                {
                    hex: '#32DA93',
                    rgb: '50, 218, 147',
                },
                {
                    hex: '#496786',
                    rgb: '73, 103, 134',
                },
                {
                    hex: '#333333',
                    rgb: '51, 51, 51',
                },
            ],
        };
    },
    mounted() {},
    methods: {
        randomColor() {
            let random = Math.floor(Math.random() * this.customColorList.length);
            let color = random == 0 ? '#B0B0C8' : this.customColorList[random].hex;
            return {
                backgroundColor: color,
            };
        },
        imgErrfn() {
            this.imgerror = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.vi_avatar {
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;

    .img {
        width: 100% !important;
        height: 100% !important;
    }

    .name {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #fff;
    }
}
</style>
;
